const IN_BROWSER = typeof window !== 'undefined';
const DOMAIN_NAME = document.domain;
const ENV = process.env.NODE_ENV;
const IN_PWA = window.matchMedia('(display-mode: standalone)').matches;

export default {
  IN_BROWSER,
  DOMAIN_NAME,
  ENV,
  IN_PWA
};

